module.exports = __webpack_public_path__ + "static/media/okrasa-srdce-otocene.c2235fcf.svg";